import { BreachPathDetailsGZDataProvider } from '../dataProvider/BreachPathDetailsGZDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class BreachPathDetailsDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, BreachPathDetailsGZDataProvider);
  }
}
